import { Box } from "@mui/material"
import {
  MRT_ColumnDef,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table"

import { defaultTableProps } from "./config"
import { useSelector } from "react-redux"
import { CircleIndicator, TickIndicator } from "./Atom"
import { useAppSelector } from "../../../redux/hooks"
import ProntoAiMetricNameCell from "../Cell/ProntoAiMetricNameCell"
import { useState } from "react"
import ProntoAiDrawer from "../../Drawer/ProntoAiDrawer"
import { colors } from "../../../../styles/commonStyles"

type ProntoAiTableProps = {
  handleFetchStoreById: any
}

export type Anchor = "top" | "left" | "bottom" | "right"

const ProntoAiTable = (props: ProntoAiTableProps) => {
  const { handleFetchStoreById } = props

  const loading = useAppSelector((state) => state.app.loading)

  const prontoAiColumns: {
    column_name: string
    column_id: string
  }[] = useSelector((state: any) => state.prontoAi?.prontoAiColumns)

  const data = useSelector((state: any) => state.prontoAi?.prontoAiTableData)

  const selectedMetric = useSelector((state: any) => {
    return state.prontoAi.selectedMetric
  })

  const [state, setState] = useState({
    right: false,
  })

  const toggleDrawer =
    (anchor: Anchor, open: boolean) => (event: KeyboardEvent | MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as KeyboardEvent).key === "Tab" ||
          (event as KeyboardEvent).key === "Shift")
      ) {
        return
      }

      setState({ ...state, [anchor]: open })
    }

  function closeSidebar() {
    setState({ right: false })
  }

  const columns: MRT_ColumnDef<any>[] = prontoAiColumns?.map(
    (columnData: { column_name: string; column_id: string }) => {
      return {
        accessorKey: columnData?.column_id,
        header: columnData?.column_name
          .replaceAll("_", " ")
          .replaceAll("percent", "%")
          .replaceAll("dollar", "$")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        muiTableHeadCellProps:
          columnData?.column_name === "Office" ||
          columnData?.column_name === "Metric"
            ? {
                align: "left",
              }
            : { align: "center" },
        Cell: ({ cell, row, renderedCellValue }) =>
          renderedCellValue ? (
            columnData?.column_id == "previous_month_goal_impact" ||
            columnData?.column_id == "benchmark_impact" ? (
              `$ ${parseFloat(renderedCellValue as string).toLocaleString()}`
            ) : (columnData?.column_id as string).includes("Month") ||
              (columnData?.column_id as string).includes("Trend") ||
              (columnData?.column_id as string).includes("TTM") ||
              (columnData?.column_id as string).includes("Year") ? (
              <CircleIndicator color={renderedCellValue} />
            ) : (columnData?.column_id as string).includes("Metric") ? (
              <ProntoAiMetricNameCell
                row={row}
                renderedCellValue={renderedCellValue}
                toggleDrawer={toggleDrawer}
                handleFetchStoreById={handleFetchStoreById}
              />
            ) : (columnData?.column_id as string).includes("practice_name") ? (
              `${renderedCellValue}`
            ) : (
              <TickIndicator />
            )
          ) : (
            renderedCellValue
          ),
        size: (columnData?.column_id as string).includes("Metric") ? 280 : 100,
        muiTableBodyCellProps:
          columnData?.column_name === "Office"
            ? {
                align: "left",
                sx: {
                  border: "0.5px solid #E4E4E4",
                  boxShadow: "#00000022 1.95px 0px 2.6px",
                  color: "black",
                  fontWeight: "600",
                },
              }
            : columnData?.column_name === "Metric"
            ? {
                align: "left",
                sx: {
                  border: "0.5px solid #E4E4E4",
                  boxShadow: "#00000022 1.95px 0px 2.6px",
                  color: "black",
                  fontWeight: "600",
                  padding: "0 !important",
                  "&:hover": {
                    border: "1px solid #E4E4E4",
                    transition: "none",
                  },
                },
              }
            : {},
      }
    },
    [selectedMetric],
  )
  //   accessorKey: "metric_name",
  //   Header: ({ row }: any) => (
  //     <OpportunityHeader headerName={`Metric Name`} width={`300px`} />
  //   ),
  //   Cell: ({ row, renderedCellValue }: any) => (
  //     <OpportunityMetricNameCell
  //       row={row}
  //       renderedCellValue={renderedCellValue}
  //     />
  //   ),
  //   minSize: 280,
  //   Filter: ({ header, column }: any) => (
  //     <MetricOpportunitySearchFilter
  //       header={header}
  //       column={column}
  //       handleSearchFn={handleSearchFn}
  //     />
  //   ),
  //   filterFn: (row: any, _columnIds: any, filterValue: any) =>
  //     row?.original?.metric_name
  //       .toLowerCase()
  //       .includes(filterValue.toLowerCase()),
  //   enableEditing: false,
  //   enablePinning: true,
  //   enableColumnFilter: true,
  //   muiTableBodyCellProps: () => ({
  //     sx: metricNameCellStyles,
  //   }),
  // },

  const table = useMaterialReactTable({
    // Essential & default Props

    ...defaultTableProps,
    columns: columns,
    data: data,

    //? Extra Props

    muiTableBodyRowProps: ({ row }: any) => ({
      hover: false,
      sx: {
        backgroundColor:
          selectedMetric?.metric_id == row?.original?.metric_id
            ? colors.backgroundBlue
            : colors.primaryWhite,
      },
    }),

    //? Overridden Default Props

    //? Table Action Methods

    //? Table State

    state: {
      isLoading: loading,
      columnVisibility: { Actions: true },
      columnPinning: {
        left: ["practice_name", "Metric"],
        //   right: ["mrt-row-actions"],
      },
    },

    //? Overridden default styling

    //? Component Styling
  })

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <MaterialReactTable table={table} />
      <ProntoAiDrawer
        state={state}
        toggleDrawer={toggleDrawer}
        closeSidebar={closeSidebar}
      />
    </Box>
  )
}

export default ProntoAiTable
